import { Divider, Grid2, Typography, Stack } from '@mui/material';
import React from 'react';
import { useIntl, defineMessages } from 'react-intl';

import { useSession } from '@hooks/useSession';

const messages = defineMessages({
  recipient: {
    id: 'shareHistory.recipient',
    defaultMessage: 'Recipient',
  },
  created: {
    id: 'shareHistory.createdOn',
    defaultMessage: 'Created On',
  },
  expires: {
    id: 'shareHistory.expiresOn',
    defaultMessage: 'Expires On',
  },
});

interface SharingMobileRowProps {
  data: (string | React.ReactNode)[];
  dataIndex: number;
}
export default function SharingMobileRow({
  data,
  dataIndex,
}: SharingMobileRowProps) {
  const { formatMessage } = useIntl();
  const {
    state: { isPractitioner },
  } = useSession();

  // Order of table columns
  const [
    created_on,
    patient_user,
    recipient,
    resource,
    status,
    expires_on,
    actions,
  ] = data;

  return (
    <tr key={dataIndex} style={{ height: 'auto' }}>
      <td style={{ paddingTop: dataIndex === 0 ? 20 : 10, paddingBottom: 5 }}>
        <Grid2 container p={2} spacing={3}>
          <Grid2 size={{ xs: 6 }}>
            <Stack>
              {isPractitioner ? patient_user : null}
              {resource}
            </Stack>
          </Grid2>
          <Grid2 size={{ xs: 6 }} textAlign="right">
            {status}
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <Typography variant="caption">
              {formatMessage(messages.recipient)}
            </Typography>
            {recipient}
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <Typography variant="caption">
              {formatMessage(messages.created)}
            </Typography>
            <Typography color="text.secondary" variant="body1">
              {created_on}
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 7 }}>
            <Typography variant="caption">
              {formatMessage(messages.expires)}
            </Typography>
            <Typography color="text.secondary" variant="body1">
              {expires_on}
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 5 }} textAlign="right">
            {actions}
          </Grid2>
        </Grid2>
        <Divider />
      </td>
    </tr>
  );
}
